import { useCallback, useEffect, useState } from 'react'
import { extractErrorMessage, success, failure } from 'utils/errorHandling'
import useInnovaAxios from 'components/common/hooks/useInnovaAxios'

export function useErrorModels() {
  const getErrorModelHeadersRequest = useInnovaAxios({ url: '/errorModels/getErrorModelHeaders' })

  const [errorModelHeaders, setErrorModelHeaders] = useState([])
  const [missingErrorModelHeaders, setMissingErrorModelHeaders] = useState([])

  const [isLoadingErrorModelHeaders, setIsLoadingErrorModelHeaders] = useState(false)

  useEffect(() => {
    fetchErrorModelHeaders()
  }, []) //eslint-disable-line react-hooks/exhaustive-deps

  /* ============================================================
     Fetch Error Model Headers
     ============================================================ */

  const fetchErrorModelHeaders = useCallback(async () => {
    setIsLoadingErrorModelHeaders(true)
    try {
      const res = await getErrorModelHeadersRequest()
      if (res?.error) {
        return failure(extractErrorMessage(res.error, 'Failed to fetch error model headers'))
      }
      if (Array.isArray(res?.data?.ErrorModelData)) {
        setErrorModelHeaders(res.data.ErrorModelData.filter((item) => !item.missing))
        setMissingErrorModelHeaders(res.data.ErrorModelData.filter((item) => item.missing))
      }
      return success('Error model headers loaded')
    } finally {
      setIsLoadingErrorModelHeaders(false)
    }
  }, [getErrorModelHeadersRequest])

  return {
    fetchErrorModelHeaders,
    errorModelHeaders,
    missingErrorModelHeaders,
    isLoadingErrorModelHeaders,
  }
}

export default useErrorModels
